import React from 'react';
import "@fontsource/plus-jakarta-sans";
const WelcomePartner = () => {

  const partnerImage = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/partners.svg';

  return (
    <div className="container-fluid p-20" style={{ backgroundColor: '#F6FBFF' ,padding:'60px',fontFamily: "'Plus Jakarta Sans', sans-serif"}}>
      <div className="row align-items-center justify-content-center">
        <div className="col-md-7 text-center text-md-start">
          <h1 className='font-25' style={{ color: '#00539A', fontSize: '40px',fontWeight:'800',fontFamily: "'Plus Jakarta Sans', sans-serif"}}>
            Welcome to DataMetricks<br />
            Your Partner in Digital Growth!
          </h1>
        <p style={{ fontSize: '16px', marginTop: '15px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
  At <span style={{ color: '#000000', fontWeight: 'bold',fontFamily: "'Plus Jakarta Sans', sans-serif" }}>DataMetricks</span>, we specialize in crafting innovative web development solutions and
  dynamic digital marketing strategies to help businesses thrive in the fast-paced digital
  world. Whether you're building a brand-new website or looking to enhance your online
  presence, we’re here to turn your ideas into success.
</p>
          <p style={{ fontSize: '16px',fontWeight:'400',fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            Founded in 2016, our team of experienced developers, designers, and marketers is
            dedicated to delivering tailored, results-driven solutions. We understand your unique
            business goals and challenges, and we work collaboratively with you to create strategies
            that lead to measurable growth and long-term success.
          </p>
        </div>
        <div className="col-md-4 d-flex justify-content-center align-items-center">
         <img
  src={partnerImage}
  alt="Partner Image"
  style={{ maxWidth: '100%', height: 'auto',fontFamily: "'Plus Jakarta Sans', sans-serif" }}
/>
        </div>
      </div>
    </div>
  );
};

export default WelcomePartner;
